import { useEffect } from "react";

import { useBranding } from "@/branding/BrandingLoader";

/**
 * Phase 10C.8 — embeds a third-party live-chat widget when the
 * tenant's branding row has `chat_provider` + `chat_id` set.
 * Loads once and removes the script on unmount so flipping providers
 * via admin doesn't leave stale globals around.
 */
export function ChatWidget() {
  const branding = useBranding();
  const provider = branding?.branding?.chat_provider;
  const id = branding?.branding?.chat_id;

  useEffect(() => {
    if (!provider || !id) return;
    const script = document.createElement("script");
    script.async = true;
    switch (provider) {
      case "crisp":
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).$crisp = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).CRISP_WEBSITE_ID = id;
        script.src = "https://client.crisp.chat/l.js";
        break;
      case "intercom":
        script.src = `https://widget.intercom.io/widget/${id}`;
        break;
      case "tawk":
        script.src = `https://embed.tawk.to/${id}`;
        break;
      case "zendesk":
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${id}`;
        script.id = "ze-snippet";
        break;
    }
    document.body.appendChild(script);
    return () => {
      try {
        document.body.removeChild(script);
      } catch {
        /* noop */
      }
    };
  }, [provider, id]);

  return null;
}
